import { useContext, useState } from 'react'

import Router from 'next/router'
import { login, loginSendLink } from 'src/lib/auth-api'
import { AuthContext } from 'src/component/Context/AuthContext'

export default function useLogin(redirect) {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState('')
  const {
    auth: { loginForms },
    dispatch
  } = useContext(AuthContext)

  const updateForm = (e) => {
    dispatch({ type: 'SET_FORM', key: e.target.name, value: e.target.value })
  }

  const handleLogin = async () => {
    try {
      const user = await login(loginForms.emailAddress, loginForms.password)

      dispatch({ type: 'SET_USER', user })
      if (redirect) {
        Router.replace('/')
      }
    } catch (e) {
      if (e.response && e.response.errors) {
        setError(e.response.errors[0].message)
      } else {
        setError(e.message)
      }
    }
  }

  const handleSendMagicLink = async () => {
    try {
      const user = await loginSendLink(loginForms.emailAddress)

      setSuccess(user.success)
    } catch (e) {
      if (e.response && e.response.errors) {
        setError(e.response.errors[0].message)
      } else {
        setError(e.message)
      }
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setLoading(true)

    if (loginForms.password) {
      await handleLogin()
    } else {
      await handleSendMagicLink()
    }

    setLoading(false)
  }

  return { loading, error, loginForms, success, updateForm, handleSubmit }
}
